import { PagenatedResponse, SearchPagenateQuery } from '@models/common';
import { GetProgramReport, ProgramReport } from '@models/programReport';
import { apiClient } from '.';

const BASE_URL = '/admin/v1/program-schedules/reports';

export const searchProgramReports = async (query: SearchPagenateQuery) => {
  return apiClient.get<PagenatedResponse<GetProgramReport>>(BASE_URL, { params: query });
};

export const updateProgramReport = async (reportId: string, formData: FormData) => {
  return apiClient.patch<ProgramReport>(`${BASE_URL}/${reportId}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const deleteProgramReport = async (reportId: string) => {
  return apiClient.delete(`${BASE_URL}/${reportId}`);
};
